import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import HeroSection from "../components/home/HeroSection";
import FeatureStrip from "../components/home/FeatureStrip";
import HowItWorks from "../components/home/HowItWorks";
import GearSection from "../components/home/GearSection";
import LocationsSection from "../components/home/LocationsSection";
import WhyChoose from "../components/home/WhyChoose";
import AdventureBanner from "../components/home/AdventureBanner";
import PricingSection from "../components/home/PricingSection";
import AppShowcase from "../components/home/AppShowcase";
import SafetySection from "../components/home/SafetySection";
import FaqSection from "../components/home/FaqSection";
import ContactSection from "../components/home/ContactSection";

const Home = () => {
    useScrollReveal();

    return (
        <>
            <HeroSection/>
            <FeatureStrip/>
            <HowItWorks/>
            <GearSection/>
            <LocationsSection/>
            <WhyChoose/>
            <AdventureBanner/>
            <PricingSection/>
            <AppShowcase/>
            <SafetySection/>
            <FaqSection/>
            <ContactSection/>
        </>
    );
};

export default Home;
